import { render, staticRenderFns } from "./RecordsData.vue?vue&type=template&id=fc4e0ade"
import script from "./RecordsData.vue?vue&type=script&lang=js"
export * from "./RecordsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports